module.exports = __webpack_public_path__ + "img/4_1_1.06b355a1.jpg";